import React, { forwardRef, ButtonHTMLAttributes } from "react";
import classnames from "classnames";

import "./UnstyledButton.scss";

export const UnstyledButton = forwardRef<
  HTMLButtonElement,
  ButtonHTMLAttributes<HTMLButtonElement>
>(({ className, ...rest }, ref) => (
  <button
    ref={ref}
    className={classnames("unstyled-button", className)}
    {...rest}
  />
));

UnstyledButton.defaultProps = {
  type: "button",
};
